import React, { Component } from 'react'
import CacheKeys from '../../../../../cache/CacheKeys.js'
import CacheManager from '../../../../../cache/CacheManager.js'
import MasterTermSheetSchedulePageUI from './MasterTermSheetSchedulePageUI.js'

class MasterTermSheetGeneralPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      scheduleRowList: null,
    }
  }

  render() {
    return (
      <MasterTermSheetSchedulePageUI
        context={this.props.context}
        page='general'
        title='Schedule IV: General Terms and Conditions'
        scheduleRowList={this.state.scheduleRowList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getScheduleRows(context)
  }

  getScheduleRows(context) {
    const cacheManager = new CacheManager({
      resource: '/api/su/master/termSheet/scheduleRows',
      cacheKey: CacheKeys.TermSheetScheduleRows('master'),
      callback: this.getScheduleRowsCallback,
      ttlInSecs: 600,
    })
    cacheManager.getObject2(context, null, {
    })
  }

  getScheduleRowsCallback = (response) => {
    this.setState({
      scheduleRowList: response.scheduleRowList || [],
    })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.TermSheetScheduleRows('master'))
    if (noBusy === 'noBusy') {
      this.getScheduleRows(context)
    } else {
      this.setState({ scheduleRowList: null })
      this.getScheduleRows(context)
    }
  }
}

export default MasterTermSheetGeneralPageSF
